<template>
  <v-card
    class="outstanding-card"
    :color="cardColour"
    :class="{
      paused: poi.technicianData.paused,
      'on-site': isOnSite,
      'awaiting-internet': isPoiAwaitingInternet
    }"
  >
    <v-container fluid>
      <v-layout
        align-space-between
        justify-space-around
        column
        fill-height
      >
        <v-flex>
          <v-layout
            align-space-between
            justify-space-around
            row
            fill-height
          >
            <v-flex class="text-xs-left">
              <h3>{{ poi.name }} {{ poi.address }}</h3>
            </v-flex>
            <v-flex class="text-xs-right">
              {{ displayDateIssued }} ({{ daysOutstanding }} days)
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="fullsize">
          <v-layout
            align-center
            justify-space-around
            row
            fill-height
          >
            <v-flex class="text-xs-left">
              <span>{{ strings.confidence }}: </span>
            </v-flex>
            <v-flex class="text-xs-right">
              <span>{{ displayConfidence }}%</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="fullsize && poi.technicianData.address">
          <v-layout
            align-center
            justify-space-around
            row
            fill-height
          >
            <v-flex class="text-xs-left">
              <span>{{ strings.address }}: </span>
            </v-flex>
            <v-flex class="text-xs-right">
              <span>{{ poi.technicianData.address }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="fullsize && firstPDP.leftLogger && firstPDP.rightLogger">
          <v-layout
            align-center
            justify-space-around
            row
            fill-height
          >
            <v-flex class="text-xs-left">
              <span>{{ strings.serial }}: </span>
            </v-flex>
            <v-flex class="text-xs-right">
              <span>{{ firstPDP.leftLogger.loggerName }} -
                {{ firstPDP.rightLogger.loggerName }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout
            align-center
            justify-space-around
            row
            fill-height
          >
            <v-flex>
              <v-btn
                color="primary"
                dark
                fab
                @click="onDataButton(poi.id)"
              >
                <v-icon color="text">
                  mdi-chart-line
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn
                color="primary"
                dark
                fab
                @click="onMapButton(poi.id)"
              >
                <v-icon color="text">
                  mdi-google-maps
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn
                color="primary"
                fab
                @click="onNavigateToButton"
              >
                <NavigateTo color="text" />
              </v-btn>
            </v-flex>
            <v-flex v-if="isSuper && !isOnSite">
              <v-btn color="danger" dark @click="onUnnassign(poi)">
                Unassign
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <AreYouSure
      v-model="areYouSureUnnassign"
      action="Unassigning this POI"
      @answer="onCompleteAnswer($event)"
    />
  </v-card>
</template>

<script>
import NavigateTo from "../Icons/NavigateTo";
import { mapGetters } from "vuex";
import AreYouSure from './AreYouSure.vue';
export default {
  name: "OutstandingPoi",
  components: {
    NavigateTo,
    AreYouSure
  },
  props: ["poi", "showDetails"],
  data() {
    return {
      fullsize: true,
      selectedPoi: null,
      areYouSureUnnassign: false,
    };
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    ...mapGetters("login", ["isSuper"]),
    ...mapGetters("actions", {
      poisWaitingAction: "poisWaitingAction"
    }),
    cardColour() {
      if (this.poi.paused) {
        return "#dee2e6";
      }
      return "#fff";
    },
    displayDateIssued() {
      if (
        this.poi &&
        this.poi.technicianData &&
        this.poi.technicianData.dateIssued
      ) {
        let date = new Date(this.poi.technicianData.dateIssued);
        return date.toLocaleDateString();
      } else return new Date();
    },
    daysOutstanding() {
      var date1 = new Date();
      var date2 = new Date(this.poi.technicianData.dateIssued);
      var timeDiff = Math.abs(date1 - date2);
      var dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

      if(dayDiff < 0) {
        dayDiff = 0;
      }
      return dayDiff;
    },
    displayConfidence() {
      if (this.poi && this.poi.pois && this.poi.pois[0].confidence) {
        return this.poi.pois[0].confidence.toFixed(0);
      } else return new Date();
    },
    firstPDP() {
      return this.poi.pois[0];
    },
    isPoiAwaitingInternet() {
      return this.poisWaitingAction.includes(this.poi.id);
    },
    isOnSite() {
      if (
        this.poi.technicianData &&
        this.poi.technicianData.onSiteTimes.length > 0
      ) {
        let arraySize = this.poi.technicianData.onSiteTimes.length;
        let lastOnSite = this.poi.technicianData.onSiteTimes[arraySize - 1];
        if (!lastOnSite.leaving) return true;
      }
      return false;
    }
  },
  mounted() {},
  methods: {
    onDataButton(id) {
      this.$store.commit("poi/setActiveGroupPoi", id);
      this.$router.push({ name: "dataDetail", params: { id } }).catch(() => {});
    },
    onMapButton(id) {
      this.$store.commit("poi/setActiveGroupPoi", id);
      this.$router.push({ name: "mapDetail", params: { id } }).catch(() => {});
    },
    onUnnassign(poi) {
      this.selectedPoi = poi;
      this.areYouSureUnnassign = true;
    },
    onCompleteAnswer(answer) {
      if(answer) {
        this.$store.dispatch("poi/UnassignPoi", this.selectedPoi)
        .then(res => {
          this.areYouSureUnnassign = false;
        })
      }
      else {
        this.areYouSureUnnassign = false;
      }
      
    },
    onNavigateToButton() {
      let lat = this.firstPDP.latitude;
      let lng = this.firstPDP.longitude;
      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPad") != -1 ||
        navigator.platform.indexOf("iPod") != -1
      )
        window.open(`maps://maps.google.com/maps?daddr=${lat},${lng}&amp;ll=`);
      /* else use Google */ else
        window.open(`https://maps.google.com/maps?daddr=${lat},${lng}&amp;ll=`);
    }
  }
};
</script>

<style scoped>
.outstanding-card {
  margin: 0.5em;
}
</style>
